module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br'), _c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c01_r1"
    }
  }, [_vm._v("Chapter 1 - Tribe and Tradition: The Northern Tradition Landscape")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 - Defining Devotion: The Evolution of Practice")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 - Nine Worlds of Spirit: Core Cosmology")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morning Prayer to Sunna")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer to the Elements")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evening Prayer to Mani")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 - In Reverence: Meditation and Prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meditation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayers for Personal Devotions")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Praise of the Vanadis")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanir Meal Blessing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parent’s Prayer for Patience")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Faith")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c04_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of the Lone Worshipper")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 - Counting on Faith: Prayer Beads")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raven’s Bead Prayers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galina’s Bead Prayer for Heathen Healers First Section")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thor’s Prayer Beads")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sigyn Prayer Beads")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frey Prayer Beads, Short Version")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frey Prayer Beads")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 - Footsteps to the Gods: Solitary Rites")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Constructing Solid Ritual")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pitfalls of the Path")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devotional Ritual for Sigyn")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devotional Ritual for Njord")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solitary Rite for the Ancestors")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rite for the Land-Wight")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c06_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rite for Tyr")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 - Sacred Images: Altar Work and God-Posts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting Up Your First Altar")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God-Posts")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 - Right Action: Doing the Work")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 - Sacred Inquiry: The Conundrum of Words")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_ap1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Deity Altars and Offerings")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_nts_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_bib_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_bm2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Further Reading")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601639547_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479a7f96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bano_9781601639547_oeb_toc_r1.vue
// module id = 57
// module chunks = 0